export const visit = (vm, at) => {
at({ "en": { "editColumnsDealQuotesCoachingTip": { "title": "View Associated Quotes", "body": "To view associated Quotes, click \"Edit columns\" and choose the \"Deal \u2192 Quotes\" column", "primaryAction": "Select \"Edit columns\"" } } });
};